import { Component, OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Subject, takeUntil } from 'rxjs';
import { ToastrService } from 'ngx-toastr';
import { ExtraAnnualAssemblyDetail, SessionOrderType, BoardPosition, BoardMembershipType, LegalCompanyType, InspectorType, WageAndGiftFieldType, ProportionedRetainedEarningFieldName } from 'src/app/models/extra-annual-assembly';
import { ExtraAnnualAssemblyService } from 'src/app/services/extra-annual-assembly.service';
import { AnnualAssemblyEnumService } from 'src/app/services/annual-assembly-enum.service';
import toToman from 'src/app/utils/toToman';

@Component({
  selector: 'app-extra-annual-assembly-detail',
  templateUrl: './extra-annual-assembly-detail.component.html',
  styleUrls: ['./extra-annual-assembly-detail.component.scss']
})
export class ExtraAnnualAssemblyDetailComponent implements OnInit, OnDestroy {
  detail?: ExtraAnnualAssemblyDetail;
  isLoading = true;
  private destroy$ = new Subject<void>();

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private service: ExtraAnnualAssemblyService,
    private toastr: ToastrService,
    private enumService: AnnualAssemblyEnumService
  ) {}

  ngOnInit(): void {
    const id = this.route.snapshot.paramMap.get('id');
    if (id && id.trim() !== '') {
      this.loadDetail(id);
    } else {
      this.toastr.error('شناسه گزارش نامعتبر است');
      this.router.navigate(['/extra-annual-assembly']);
    }
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }

  loadDetail(id: string): void {
    this.isLoading = true;
    this.service
      .getById(id)
      .pipe(takeUntil(this.destroy$))
      .subscribe({
        next: (res: any) => {
          this.detail = res.data || res;
          this.isLoading = false;
        },
        error: (err) => {
          console.error('Error loading extra annual assembly detail:', err);
          this.toastr.error('تصمیمات مجمع عمومی فوق‌العاده سالیانه یافت نشد.');
          this.isLoading = false;
          this.router.navigate(['/extra-annual-assembly']);
        }
      });
  }

  goBack(): void {
    this.router.navigate(['/extra-annual-assembly']);
  }

  getSessionOrderLabel(type: SessionOrderType): string {
    return this.enumService.getSessionOrderTypeLabel(type);
  }

  getBoardPositionLabel(position: BoardPosition): string {
    return this.enumService.getBoardPositionLabel(position);
  }

  getBoardMembershipLabel(type: BoardMembershipType): string {
    return this.enumService.getBoardMembershipTypeLabel(type);
  }

  getLegalTypeLabel(type: LegalCompanyType | null): string {
    return type !== null ? this.enumService.getLegalCompanyTypeLabel(type) : '-';
  }

  getInspectorTypeLabel(type: InspectorType): string {
    return this.enumService.getInspectorTypeLabel(type);
  }

  getWageTypeLabel(type: WageAndGiftFieldType): string {
    return this.enumService.getWageAndGiftFieldTypeLabel(type);
  }

  getRetainedEarningLabel(field: ProportionedRetainedEarningFieldName | null): string {
    return field !== null ? this.enumService.getProportionedRetainedEarningFieldLabel(field) : '-';
  }

  formatNumber(value: number | null | undefined): string {
    if (value === null || value === undefined) return '-';
    return value.toLocaleString('en-US');
  }

  formatPercent(value: number | null | undefined): string {
    if (value === null || value === undefined) return '-';
    return value.toFixed(2) + '%';
  }

  getTomanTooltip(value: number | null | undefined): string {
    if (value === null || value === undefined) return '';
    return toToman(value.toString());
  }
}
